import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface CurrencyEuroRatesResponse {
  base: string;
  rates: { [key: string]: number };
}

export type GetCurrencyEuroRatesCall = () => Promise<{
  data: CurrencyEuroRatesResponse;
}>;

export default (makeCall: MakeCall) => () =>
  makeCall<CurrencyEuroRatesResponse>('GET', `${APIV2_URL}/currency/EUR/rates`);
